import React from 'react';
import { Navigate } from 'react-router-dom';
import Loadable from './layouts/full/shared/loadable/Loadable';
import PrivateRoute from "./PrivateRoute";
import PublicRoute from "./PublicRoute";
import AdminRoute from "./AdminRoute";

/* ***Layouts**** */
const FullLayout = Loadable(React.lazy(() => import('./layouts/full/FullLayout')));
const BlankLayout = Loadable(React.lazy(() => import('./layouts/blank/BlankLayout')));

/* ****Pages***** */
const Dashboard = Loadable(React.lazy(() => import('./views/dashboard')))
const Email = Loadable(React.lazy(() => import('./views/email')))
const Statistics = Loadable(React.lazy(() => import('./views/email/statistics')))
const Feed = Loadable(React.lazy(() => import('./views/feed')));
const Video = Loadable(React.lazy(() => import('./views/video')));

const Profile = Loadable(React.lazy(() => import('./views/profile')));
const Error = Loadable(React.lazy(() => import('./views/auth/Error')));
const Login = Loadable(React.lazy(() => import('./views/auth/Login')));

const AdminUsers = Loadable(React.lazy(() => import('./views/admin/users')))

const Router = [
  {
    path: '/',
    element: <PrivateRoute element={<FullLayout />} />,
    children: [
      { path: '/', element: <Navigate to="/dashboard" /> },
      { path: '/dashboard', exact: true, element: <Dashboard /> },
      { path: '/profile', exact: true, element: <Profile /> },
      { path: '/feed', exact: true, element: <Feed /> },
      { path: '/email', exact: true, element: <Email /> },
      { path: '/statistics', exact: true, element: <Statistics /> },
      { path: '/video', exact: true, element: <Video /> },
      { path: '*', element: <Navigate to='/404' /> },
    ],
  },
  {
    path: '/admin',
    element: <AdminRoute element={<FullLayout />} />,
    children: [
      { path: '/admin/users', element: <AdminUsers /> },
      { path: '*', element: <Navigate to='/404' /> },
    ],
  },
  {
    path: '/auth',
    element: <PublicRoute element={<BlankLayout />} />,
    children: [
      { path: '/auth/login', element: <Login /> },
      { path: '*', element: <Navigate to='/404' /> },
    ],
  },
  { path: '/404', element: <Error /> },
];

export default Router;